<script>
import { throttle } from 'lodash'

/**
 * Vue mixin to listen for viewport changes
 */
export const ViewportDetectionMixin = {
  data () {
    return {
      viewport: null
    }
  },

  mounted () {
    this.$bus.$on('viewport-change', (viewport) => {
      this.viewport = viewport
    })
    this.$nextTick(() => {
      this.$bus.$emit('get-viewport')
    })
  },
}

/**
 * Vue component to track viewport changes - should be used only once
 */
export default {
  name: 'viewport-detection',

  data () {
    return {
      viewport: null
    }
  },

  mounted () {
    this.setViewport()
    this.$nextTick(() => {
      window.addEventListener('resize', _.throttle(this.setViewport, 300))
    })
    this.$bus.$on('get-viewport', _.throttle(this.publishViewport, 500))
  },

  watch: {
    viewport: {
      immediate: true,
      handler () {
        this.publishViewport()
      }
    }
  },

  methods: {
    publishViewport () {
      this.$bus.$emit('viewport-change', this.viewport)
    },

    setViewport () {
      for ( var child of this.$el.children ) {
        if (child.offsetHeight > 0) {
          this.viewport = child.getAttribute('value')
          return
        }
      }
    }
  }
}
</script>

<template>
  <div>
    <div value="xlarge" class="show-for-xlarge-only">&nbsp;</div>
    <div value="large" class="show-for-large-only">&nbsp;</div>
    <div value="medium" class="show-for-medium-only">&nbsp;</div>
    <div value="mediumlarge" class="show-for-mediumlarge-only">&nbsp;</div>
    <div value="small" class="show-for-small-only">&nbsp;</div>
  </div>
</template>

<style scoped>
div { height: 1px; }
</style>


// WEBPACK FOOTER //
// src/components/ViewportDetection.vue